<template>
    <div class="face">
        <div class="banner_top">
            <swiper :options="swiperOption" ref="mySwiper" id="imgHeight">
                <swiper-slide v-for="(item, i) in slideShowList" :key="i">
                    <img :src="item.sylbAddress" alt="" />
                </swiper-slide>
            </swiper>
            <!-- <video src="https://resource.teld.cn/telddoc/107/teld-official-index-beta-06.mp4" autoplay="autoplay" loop="loop"  muted="muted" ></video> -->
        </div>
        <!-- 公司简介 -->
        <div class="companyIntroduction">
            <div class="widthrules">
                <div class="twoBoxs">
                    <div class="big_title">
                        <div class="bigTitle">{{ jjTitleName }}</div>
                    </div>
                </div>
                <div class="bgc">
                    <!-- 设置在动画结束后把标志位置false -->
                    <!-- @animationend='inAnimation=false' -->
                    <div :class="inAnimation ? 'imgMove' : ''">
                        <img
                            v-show="inAnimation"
                            class="companyImg"
                            src="https://bj.prova-newenergy.com.cn/profile/upload/2024/11/28/1_20241128101945A172.jpg"
                            alt=""
                        />
                    </div>
                    <div :class="inAnimation ? 'companyText' : ''">
                        <div v-show="inAnimation" class="companyTitle">{{ this.companyList.title }}</div>
                        <div v-show="inAnimation" class="companyTitle2">{{ this.companyList.titleB }}</div>
                        <div v-show="inAnimation" :class="languageType == 1 ? 'companyNote' : 'companyNotes'">
                            {{ this.companyList.contentA }}
                            {{ this.companyList.contentB }}
                        </div>
                        <!-- <div v-show="inAnimation" :class="languageType == 1 ? 'companyNote' : 'companyNotes'">
                           
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 业务板块 -->
        <div class="widthrules">
            <div class="topBox">
                <div class="twoBoxs">
                    <div class="big_title">
                        <div class="bigTitle">{{ ywTitleName }}</div>
                    </div>
                </div>
                <div class="changeful_box">
                    <div :class="'img' + idx" v-for="(item, idx) in ywbktpList" :key="item.ywbktpId" @click="operation(item)">
                        <div class="html">
                            <div class="zw" v-if="languageType == 1">{{ item.backup }}</div>
                            <div class="yw" v-if="languageType == 2">{{ item.backup1 }}</div>
                            <div class="ew" v-if="languageType == 3">{{ item.backup2 }}</div>
                        </div>
                        <img :src="item.ywbktpAddress" alt="" />
                        <div class="mask_layer"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 产品中心 -->
        <div class="product_box">
            <div class="widthrules">
                <div class="twoBoxs">
                    <div class="big_title">
                        <div class="bigTitle" style="color: #fff">{{ projectMenuTitle }}</div>
                    </div>
                </div>
                <div class="product_menu">
                    <div class="product_menu_content">
                        <el-menu
                            mode="horizontal"
                            class="el-menu-vertical-demo"
                            background-color="#fff"
                            text-color="#3d3d3d"
                            active-text-color="#fff"
                            default-active="0"
                            @select="handleSelect"
                        >
                            <el-menu-item v-for="(item, idx) in productMenuList" :key="item.menuId" :index="idx.toString()">
                                <span slot="title">{{ item.guideZw }}</span>
                            </el-menu-item>
                        </el-menu>
                    </div>
                    <div class="product_details">
                        <div class="product_details_content">
                            <div class="content_box" v-for="item in productList" :key="item.productId">
                                <div class="content_img">
                                    <img class="img" :src="item.backup1" alt="" />
                                </div>
                                <div class="content_title">{{ item.backup }}</div>
                                <div class="content_brief">{{ item.productBrief }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 新闻资讯 -->
        <div class="widthrules">
            <div class="topBox" style="position: relative">
                <div class="twoBoxs">
                    <div class="big_title">
                        <div class="bigTitle">{{ xwTitleName }}</div>
                    </div>
                </div>
                <div class="news">
                    <div
                        class="newsBox"
                        v-for="item in newsListsInfo0.slice(0, 1)"
                        :key="item.id"
                        @click="article(item.id)"
                        style="cursor: pointer"
                    >
                        <div class="type_box">
                            <span class="type_span">{{ newsListsName0 }}</span>
                        </div>
                        <div class="imgBox">
                            <img class="img" :src="item.pic" style="width: 100%" alt="" />
                        </div>
                        <div class="infoBox">
                            <div class="infoTitle">{{ item.title }}</div>
                            <div class="infoText">
                                {{ item.brief }}
                            </div>
                        </div>
                    </div>
                    <div class="newsBox_two">
                        <div v-for="item in newsListsInfo0.slice(1, 4)" :key="item.id" class="box_flex" @click="article(item.id)">
                            <div class="left">
                                <img class="img" :src="item.pic" style="width: 100%" alt="" />
                            </div>
                            <div class="right">
                                <div class="title">{{ item.title }}</div>
                                <div class="info">{{ item.brief }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more_btn" @click="more()">更 多 资 讯</div>
            </div>
        </div>
        <!-- 荣誉资质 -->
        <div style="background: #0a437c;">

            <div class="widthrules">
                <div class="twoBoxs">
                    <div class="big_title">
                        <div class="bigTitle" style="color: #fff;">{{ryTitleName}}</div>
                    </div>
                </div>
                <div class="ryzsBox">
                    <div class="top">
                        <img src="../../assets/img/images/ryzs1.png" alt="">
                        <img src="../../assets/img/images/ryzs2.png" alt="">
                        <img src="../../assets/img/images/ryzs3.png" alt="">
                        <!-- <img src="../../assets/img/images/ryzs4.png" alt=""> -->
                    </div>
                    <div class="btm">
                    </div>
                </div>
            </div>
        </div>

        <v-footer></v-footer>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import vFooter from '../common/footer.vue';
import 'swiper/dist/css/swiper.css';
import {
    gwGetSYLBList,
    getGWClassNewsInfor,
    getGWProductInfoList,
    getGWProductInfoListById,
    selectGwYwbktp,
    gwGetHomeInfoTitle,
    gwGetHomeAbout
} from '@/api/index';
export default {
    name: 'face',
    components: {
        swiper,
        swiperSlide,
        vFooter
    },
    data() {
        return {
            inAnimation: false,
            languageType: '1',
            slideShowList: [],
            newsListsName0: '',
            // newsListsName1: '',
            newsListsInfo0: [],
            // newsListsInfo1: [],
            swiperOption: {
                init: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                    autoplayDisableOnInteraction: false
                },
                loop: true //开启环路
            },
            project_active: '',
            projectMenuTitle: '',
            jjTitleName: '', // 公司标题
            xwTitleName: '', // 新闻标题
            ywTitleName: '', // 业务标题
            ryTitleName:'',//荣誉资质
            companyList: {
                title: '',
                titleB: '',
                contentA: '',
                contentB: '',
                szA: '',
                szADw: '',
                szASm: '',
                szB: '',
                szBDw: '',
                szBSm: '',
                szC: '',
                szCDw: '',
                szCSm: '',
                szD: '',
                szDDw: '',
                szDSm: ''
            },
            productMenuList: [],
            productList: [],
            ywbktpList: []
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    updated() {
        if (this.slideShowList.length > 1) {
            this.swiper.init();
        }
    },
    mounted() {
        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('position_face');
        });
        this.$nextTick(function() {
            this.scrollTos();
        }, 2000);
    },
    created() {
        this.selectGwYwbktp();
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.gwGetHomeInfoTitle();
        this.gwGetSYLBList();
        this.getGWClassNewsInfor();
        this.getGWProductInfoList();
        this.gwGetHomeAbout();
        window.addEventListener('setItem', () => {
            if (this.$route.path == '/face') {
                this.languageType = sessionStorage.getItem('languageType');
                this.gwGetHomeInfoTitle();
                this.gwGetSYLBList();
                this.getGWClassNewsInfor();
                this.getGWProductInfoList();
                this.gwGetHomeAbout();
            }
        });
        //在窗口滚动时调用监听窗口滚动方法
        window.addEventListener('scroll', this.windowScrollListener);
    },
    destroyed() {
        //离开页面时删除该监听
        window.removeEventListener('scroll', this.windowScrollListener);
    },
    methods: {
        scrollTos() {
            window.scrollTo({
                //滚动到元素位置
                top: sessionStorage.getItem('position_face'), //推荐使用，getBoundingClientRect 相对于当前视口的位置
                behavior: 'smooth' // 平滑滚动
            });
        },
        handleScroll() {
            var scrollTop = window.scrollY;
            sessionStorage.setItem('position_face', scrollTop);
        },
        //监听窗口滚动
        windowScrollListener() {
            //获取操作元素最顶端到页面顶端的垂直距离
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (scrollTop >= 150) {
                this.inAnimation = true; //大于480时显示元素
            }
            if (scrollTop < 150) {
                this.inAnimation = false; //小于480时隐藏元素
            }
        },
        gwGetHomeAbout() {
            let params = {
                language: this.languageType
            };
            gwGetHomeAbout(params).then((res) => {
                // console.log('获取公司简介', res)
                this.companyList = res.obj;
            });
        },
        gwGetHomeInfoTitle() {
            let params = {
                language: this.languageType
            };
            gwGetHomeInfoTitle(params).then((res) => {
                this.jjTitleName = res.obj.jjTitleName;
                this.xwTitleName = res.obj.xwTitleName;
                this.ywTitleName = res.obj.ywTitleName;
                this.ryTitleName = res.obj.ryTitleName;
            });
        },
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '1'
            };
            gwGetSYLBList(params).then((res) => {
                // console.log('获取首页轮播图', res);
                this.slideShowList = res.obj;
            });
        },
        selectGwYwbktp() {
            let params = {};
            selectGwYwbktp(params).then((res) => {
                // console.log('业务板块图片与文字', res);
                this.ywbktpList = res.obj;
            });
        },
        handleSelect(key) {
            // console.log('wzy-----', key);
            this.getGWProductInfoListById(this.productMenuList[key].menuId);
        },
        getGWProductInfoList() {
            let params = {
                language: this.languageType
            };
            getGWProductInfoList(params).then((res) => {
                // console.log('查询全部产品导航', res.obj[0].gList);
                // this.project_active = res.obj[0].menuId;
                this.projectMenuTitle = res.obj[0].guideZw;
                this.productMenuList = res.obj[0].gList;
                let menuId = res.obj[0].gList[0].menuId;
                this.getGWProductInfoListById(menuId);
            });
        },
        getGWProductInfoListById(menuId) {
            let params = {
                language: this.languageType,
                menuId: menuId
            };
            getGWProductInfoListById(params).then((res) => {
                // console.log('根据ID查询产品', res.obj);
                this.productList = res.obj;
            });
        },
        getGWClassNewsInfor() {
            let params = {
                language: this.languageType
            };
            getGWClassNewsInfor(params).then((res) => {
                console.log('新闻资讯列表查询根据语言查询', res.obj);
                // this.newsLists = res.obj;
                if (res.obj.length > 0) {
                    this.newsListsName0 = res.obj[0].name;
                    // this.newsListsName1 = res.obj[1].name;
                    this.newsListsInfo0 = res.obj[0].detailVOList;
                    // this.newsListsInfo1 = res.obj[1].detailVOList;
                }
            });
        },
        operation(e) {
            this.handleScroll();
            this.$router.push({
                path: '/operation',
                query: { params: e }
            });
        },
        more() {
            this.handleScroll();
            this.$router.push('/newsInformation');
        },
        article(e) {
            this.handleScroll();
            this.$router.push({
                path: '/articleInfo',
                query: { params: JSON.stringify({ id: e }) }
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.el-menu-vertical-demo .el-menu-item {
    width: 2.875rem;
    height: .5rem;
    line-height: .5rem;
    font-size: .1875rem;
}
.el-menu-vertical-demo .el-menu-item.is-active {
    background-color: #023e7a !important;
    border-bottom: none;
}
.companyIntroduction,
.topBox {
    padding-bottom: 1.25rem;
}
//业务板块
.changeful_box {
    display: flex;
    justify-content: space-between;
    .mask_layer {
        height: 4.75rem;
        background: linear-gradient(0deg, #023e7a, transparent);
        position: absolute;
        top: 0;
    }
    div {
        width: 100%;
    }
    .img0,
    .img1,
    .img2 {
        position: relative;
        width: 31.5%;
        height: 4.75rem;
        overflow: hidden;
        cursor: pointer;
    }
    .img0 img,
    .img1 img,
    .img2 img {
        transition: all 0.5s;
    }
    .img0:hover img,
    .img1:hover img,
    .img2:hover img {
        transform: scale(1.2);
    }
    img {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .html {
        color: #fff;
        font-size: .3rem;
        top: 4rem;
        position: absolute;
        font-weight: bold;
        z-index: 999;
        text-align: center;
    }
}
// 轮播图
.banner_top {
    // max-width: 1920px;
    height: 35vw;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    .swiper-container {
        width: 100%;
        height: 100%;
        .swiper-slide {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
            }
        }
    }
}

// 光标样式
@cursor-style: pointer;
.face {
    position: relative;
    // width:80%;
    // margin: auto;
}
.face .topBox {
    width: 100%;
    .oneBoxs {
        // width:80%;
        margin: auto;
        // padding:80px 100px 0 100px;
        .title {
            width: 2.5rem;
            margin-bottom: .625rem;
            .bigTitle {
                text-align: center;
                font-size: .5rem;
                font-weight: bold;
            }
            .smallTitle {
                font-size: .2rem;
                color: #2f2e2e;
                text-align: center;
            }
        }
    }
}
// 公司简介
.companyIntroduction {
    // max-width: 24rem !important;
    // height:8.75rem;
    background-image: url('../../assets/img/images/companyProfileBg.jpeg');
    background-repeat: no-repeat;
    // background-size: cover;
    background-position: center;
    position: relative;
    .bgc {
        // opacity: 0.2;
        // overflow: hidden;
        box-sizing: border-box;
        display: flex;
        justify-content:space-between;
        gap:.44271rem;
        align-items: center;
        width: 100%;
        min-height: 5.275rem;
        @keyframes Lmove {
            0% {
                transform: translateY(100%);
            }
            100% {
                transform: translateY(0%);
            }
        }
        @keyframes Rmove {
            0% {
                transform: translateY(100%);
            }
            100% {
                transform: translateY(0%);
            }
        }
        .companyText {
            animation: Lmove 0.8s linear; //infinite
            padding-left: .5rem;
            box-sizing: border-box;
            // opacity:1;
            .companyTitle {
                font-size: .375rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 800;
                color: #000;
                // line-height: 4.0625vw;
            }
            .companyTitle2 {
                font-size: .3rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 400;
                color: #023e7a;
                line-height: 1.5vw;
                margin-bottom: 1vw;
            }
            .companyNote{
                // width: 7.25rem;
                // height: 14.114583vw;
                font-size: .25rem;
                text-indent: .4rem;
                font-family: PingFangSC-Regular, PingFang SC;
                // color: #023e7a;
                line-height: .5rem;
                letter-spacing: .0125rem;
            }
            .companyNotes {
                width: 9.375rem;
                font-size: .25rem;
                font-family: PingFangSC-Regular, PingFang SC;
                line-height: .375rem;
                letter-spacing: .0125rem;
            }
            .company_more {
                // position: absolute;
                // top: 75%;
                // left: 11%;
                width: 5vw;
                margin-left: 10.875vw;
                font-size: .225rem;
                color: #fff;
                border: red solid;
                border-width: 0px 0px .0375rem 0px;
                padding: 0 0 .125rem 0;
                cursor: pointer;
            }
            .comp_data {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .dp {
                    margin: 0px .1875rem 0px .1875rem;
                    text-align: center;
                    .num {
                        font-size: .375rem;
                        font-weight: 800;
                        font-family: Times New Roman;
                        color: #023e7a;
                        span {
                            font-size: .15rem;
                            font-weight: 400;
                            font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, 'microsoft yahei', arial, STHeiTi, sans-serif;
                        }
                    }
                    .title {
                        font-size: .15rem;
                    }
                }
            }
        }
        .imgMove {
            animation: Rmove 0.8s linear;
            img {
                width: 26.5729vw;
            }
        }
    }
}

//产品中心
.el-menu.el-menu--horizontal {
    border: none;
}
.product_box {
    width: 100%;
    height: 9.25rem;
    background-image: url('../../assets/img/images/productBg.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    // display: flex;
    // justify-content: space-between;
    margin: 0px auto 0px auto;
    overflow: hidden;
    zoom: 1;
    .product_menu {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: .7375rem;
        // width: 220px;
        // height: 600px;
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
        overflow: hidden;
        zoom: 1;
        .product_menu_title {
            // width: 220px;
            color: #fff;
            font-size: .275rem;
            line-height: .875rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // background: url(http://1.krysj.cn/u/Public/Skins/m612/m6121/icon_6.jpg) no-repeat center top;
            text-align: center;
        }
        .product_menu_content {
            // width: 6.875rem;
            margin: auto;
            text-align: center;
        }
    }
    .product_details {
        width: 100%;
        height: 9.25rem;
        padding: 0px 0px 0px 0px;
        margin: 0 auto;
        overflow: hidden;
        zoom: 1;
        .product_details_title {
            height: .5125rem;
            min-height: .5125rem;
            line-height: .5125rem;
            .title_more {
                position: relative;
                float: left;
                min-width: 1.825rem;
                padding: .0063rem;
                background: url(http://1.krysj.cn/u/Public/Skins/m612/m6121/icon_4.jpg) repeat-x;
                color: #fff;
                text-align: center;
                font-size: .2rem;
                font-weight: 100;
            }
            .title_more::after {
                position: absolute;
                bottom: 0;
                right: --0.55rem;
                width: .55rem;
                height: .5125rem;
                background: url(http://1.krysj.cn/u/Public/Skins/m612/m6121/icon_5.png) no-repeat;
                content: '';
            }
            .more {
                float: right;
                margin-right: .225rem;
                padding-right: .1625rem;
                background: url(http://1.krysj.cn/u/Public/Skins/m612/m6121/iFCB_sort_ico3.png) no-repeat right center;
                font-size: .15rem;
            }
        }
        .product_details_content {
            box-sizing: border-box;
            // height: 600px;
            margin-top: .125rem;
            display: -webkit-box;
            // justify-content: space-between;
            // flex-wrap: wrap;
            .content_box {
                width: 22%; //23.93783%
                margin-right: 4%;
                // height: 300px;
                position: relative;
                border-radius: .25rem;
                padding: .25rem .125rem;
                overflow: hidden;
                // transition: all 0.3s ease 0s;
                background-color: #fff;
                box-sizing: border-box;
                .content_img {
                    overflow: hidden;
                    width: 3.125rem;
                    height: 3.125rem;
                    .img {
                        width: 100%;
                        height: 100%;
                        transition: all 0.6s ease-in-out;
                        transform: scale(1);
                        object-fit: fill; // contain 保持原有比例；fill 默认 拉伸填充满
                    }
                }
                .content_title,
                .content_brief {
                    width: auto;
                    margin: 0 0;
                    position: relative;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                }
                .content_title {
                    margin-top: .2188rem;
                    font-size: .2188rem;
                    color: #000000;
                    font-weight: bold;
                }
                .content_brief {
                    font-size: .175rem;
                    margin-top: .0875rem;
                }
            }
            .content_box:hover {
                background: #fafafa;
                box-shadow: 0 0 .125rem #ddd;
                .img {
                    transform: scale(1.1);
                }
            }
        }
    }
}
//新闻资讯
.news {
    width: 100%;
    height: 5.625rem;
    display: flex;
    justify-content: space-between;
    .newsBox {
        // display: flex;
        width: 49%;
        height: 100%;
        text-decoration: none;
        background-color: #f8f8f8;
        position: relative;
        .type_box {
            top: 0;
            // left: 15px;
            left: 0;
            position: absolute;
            padding: .0875rem .25rem;
            text-align: center;
            max-width: 90%;
            z-index: 8;
            background-image: url(https://www.huawei.com/Assets/corp/2020/img/exhibition/type2.png);
            .type_span {
                color: #fff;
                font-size: .1625rem;
                display: block;
                width: 100%;
                height: 100%;
            }
        }
        .imgBox:hover img{transform: scale(1.1);}
        .imgBox {
            width: 100%;
            height: 70%;
            overflow: hidden;
            display: flex;
            
            .img {
                max-width: none;
                object-fit: cover;
                object-position: top;
                justify-content: center;
                align-items: center;
                transform: scale(1);
                transition: all 0.5s;
            }
        }
        .infoBox {
            text-align: left;
            padding: .275rem .225rem .325rem .225rem
            ;
            word-break: break-word;
            overflow: hidden;
            overflow-wrap: break-word;
            // height: 9.6em;
            font-family: Microsoft YaHei, Arial, Helvetica, sans-serif;
            .infoTitle {
                font-weight: bold;
                font-size: .25rem;
                line-height: 1.625em;
                color: #333;
                overflow-x: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                margin-bottom: .025rem;
            }
            .infoTime {
                font-size:.1969rem;
                height: .45rem;
                color: #333;
                overflow: hidden;
                margin-bottom: 0px;
            }
            .infoText {
                font-size: .2rem;
                line-height: 1.6875em;
                color: #666;
                // clear: both;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }
    }
    .newsBox_two {
        width: 49%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .box_flex:hover {cursor: pointer;}
        .box_flex:hover .left img{transform: scale(1.1);}
        .box_flex {
            background-color: #f7f7f7;
            width: 100%;
            display: flex;
            height: 1.875rem;
            justify-content: space-between;
            align-items: center;
            padding: .1875rem;
            box-sizing: border-box;
            .left {
                width: 30%;
                img {
                    width: 100%;
                    height: 1.25rem;
                    object-fit: cover;
                    transition: all 0.6s ease-in-out;
                    transform: scale(1);
                    object-fit: fill; // contain 保持原有比例；fill 默认 拉伸填充满
                }
            }
            .right {
                width: 66%;
                .title {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: .25rem;
                    font-weight: 500;
                    color: #000;
                    margin-bottom: .1rem;
                    -webkit-line-clamp: 1;
                }
                .info {
                    font-size: .2rem;
                    color: #3d3d3d;
                    -webkit-line-clamp: 3;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
// 模块大标题
.twoBoxs {
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    // background-image: url(../../assets/img/images/news01.png);
    background-repeat: no-repeat;
    background-size: 62%;
    .big_title {
        width: 100%;
        // margin-bottom:50px;
        font-style: italic;
        z-index: 999;
        // padding-top:80px;
        // font-family: serif;
        font-weight: bold;
        .bigTitle {
            color:#353535;
            text-align: center;
            font-size: .5rem;
            font-weight: bold;
            font-style: italic;
            text-shadow: .0125rem .0125rem .025rem #000000;
            // padding-top:60px;
        }
    }
}
.more_btn {
    width: 2.125rem;
    height: .5rem !important;
    line-height: .475rem !important;
    font-size: .25rem;
    border: .0125rem solid #111;
    text-align: center;
    margin: auto;
    margin-top: .375rem;
}
.more_btn:hover {
    background-color: #023e7a;
    cursor: pointer;
    color: #fff;
    border: .0125rem solid #023e7a;
}
// 荣誉证书
.ryzsBox {
    width: 100%;
    .top, .btm {
        // margin: auto;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: .25rem;
    }
    img {
        width: 23.3%;
        height: 2.6rem;
        border: .0125rem solid #d8d6d6;
        border-radius: .1rem;
        object-fit: cover;
        transition: all 0.4s ease-in-out;
        transform: scale(1);
        object-fit: fill;
    }
    img:hover {transform: scale(1.1);}
    padding-bottom: .6rem;
}
</style>
